import { getUserDocument } from './getUserDocument'

import { setDoc, updateDoc } from 'firebase/firestore/lite'
import refs from '../refsLite'
import { getOrCreateCurrentUserDocument } from './getOrCreateCurrentUserDocument'

export async function updateCurrentUserDocument(authUser, updateObj = {}) {
  const userId = authUser.uid
  let userData = await getOrCreateCurrentUserDocument(authUser)
  if (authUser.displayName?.trim()) {
    const name = authUser.displayName.trim()
    if (name !== userData.displayName?.trim()) {
      updateObj.displayName = name
    }
    if (name !== userData.name?.trim()) {
      updateObj.name = name
    }
  }

  if (authUser.email && authUser.email.trim() !== userData.email?.trim()) {
    updateObj.email = authUser.email.trim()
  }

  if (
    authUser.photoURL &&
    authUser.photoURL.trim() !== userData.photoURL?.trim()
  ) {
    updateObj.photoURL = authUser.photoURL
  }
  if (authUser.metadata?.lastSignInTime) {
    updateObj.lastSignIn = +Date.parse(authUser.metadata.lastSignInTime)
  }
  updateObj.lastSeen = +new Date()
  await updateDoc(refs.user(userId), updateObj)
  return await getUserDocument(userId)
}
